import React from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import GlobalToaster from "./components/common/GlobalToaster";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { authRoutes, nonAuthRoutes, userRoutes } from "./routes/AllRoutes";
import AuthLayout from "./routes/middleware/AuthLayout";
import NonAuthLayout from "./routes/middleware/NonAuthLayout";
import UserLayout from "./routes/middleware/UserLayout";
import NotFound from "./components/common/NotFound";
import ScrollToTop from "./components/common/ScrollToTop";
import { CartProvider } from "./context/CartContext";
const App = () => {
  // Renders authenticated routes
  const renderAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={`/admin${route.path}`}
        element={<AuthLayout>{route.component}</AuthLayout>}
      />
    ));
  };

  // Renders non-authenticated routes
  const renderNonAuthRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<NonAuthLayout>{route.component}</NonAuthLayout>}
      />
    ));
  };

  const renderUserRoutes = (routes) => {
    return routes.map((route, idx) => (
      <Route
        key={idx}
        path={route.path}
        element={<UserLayout>{route.component}</UserLayout>}
      />
    ));
  };

  return (
    <React.Fragment>
      <BrowserRouter>
        <AdminAuthProvider>
          <CartProvider>
            <div>
              <Routes>
                {renderNonAuthRoutes(nonAuthRoutes)}
                {renderAuthRoutes(authRoutes)}
                {renderUserRoutes(userRoutes)}

                <Route path="*" element={<NotFound />} />
              </Routes>
              <Toaster></Toaster>
            </div>
            <ScrollToTop />
            <GlobalToaster />
          </CartProvider>
        </AdminAuthProvider>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default App;
